import React from 'react';
import { Autocomplete, TextField } from '@mui/material';
import Popper from '@mui/material/Popper';

const styles = () => ({
  popper: {
    maxWidth: 'fit-content',
  },
});

const PopperMy = (props) => (
  // eslint-disable-next-line react/jsx-props-no-spreading
  <Popper {...props} style={styles.popper} />
);

const EnumSelectorBase = ({
  name,
  options,
  value,
  onChange,
  getOptionLabel,
  isOptionEqualToValue,
  renderOption,
}) => (
  <Autocomplete
    options={options}
    PopperComponent={PopperMy}
    onChange={(_event, newValue) => {
      onChange(newValue);
    }}
    getOptionLabel={getOptionLabel}
    isOptionEqualToValue={isOptionEqualToValue}
    value={value}
    renderOption={renderOption}
    // eslint-disable-next-line react/jsx-props-no-spreading
    renderInput={(params) => <TextField label={`Select ${name}`} {...params} />}
    fullWidth
    selectOnFocus
  />
);

export default EnumSelectorBase;
